// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
export enum AuthType {
  STANDARD = "Standard",
  IAM_IDENTITY_CENTER = "IAM_Identity_Center",
}
